/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { Select, Dropdown, Badge, message, Tooltip } from "antd";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import moment from "moment-jalaali";
import strings from "../utils/strings";
import { isEmpty } from "lodash";
import { clearAllRedisDb } from "../utils/clearCache";
import { usePersistedStore } from "../store/persisted-store";
import { useGeneralStore } from "../store/slices/createGeneralSlice";
import { useReportsStore } from "../store/slices/createReportsSlice";
import { applyBusinessTheme } from "../utils/applyBusinessTheme";
import ClearCDNCacheModal from "../components/businesses/ClearCDNCacheModal";
import { useView } from "../hooks/useView";
import { useTheme } from "../hooks/useTheme";

const Layout = ({ children, onPageTile }) => {
  const { isMobile, isTablet } = useView();
  const { theme, toggleTheme } = useTheme();
  const { logOut, business, auth, RESET_APP, users, setCurrentBusinessToken, getBusinesses, getcurrentBusinessBytoken, clearCDNCaches } = usePersistedStore();
  const general = useGeneralStore();
  const reports = useReportsStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [cdnCacheModalOpen, setCdnCacheModalOpen] = useState(false);
  const [clearCacheLoading, setClearCacheLoading] = useState(false);
  const [topbarHidden, setTopbarHidden] = useState(false);
  const [topbarScrolled, setTopbarScrolled] = useState(false);
  const lastScrollY = useRef(0);
  const url = location.pathname.split('/')[1];
  const userInfo = auth.userInfo;
  const userBusinesses = users.businesses;
  const businessLoading = business?.businesses?.loading;
  const businessByToken = business?.businesses?.byToken;
  const businessToken = business?.currentBusiness?.token;
  const notifications = general?.notifications?.data;

  const businesses = business?.businesses?.all;
  const getAllBusinussArray = (businesses) => businesses ? Object.keys(businesses).map(token => businesses[token]) : [];
  const allBusinussArray = getAllBusinussArray(businesses);
  const primaryColor = businessByToken?.styles?.primaryColor
  const sourceOfBusinessChange = businessByToken?.source;

  useEffect(() => {
    if (userBusinesses.length && !businessToken)
      setCurrentBusinessToken(userBusinesses[0].token);
  }, [businessToken, userBusinesses]);

  useEffect(() => {
    if (primaryColor && sourceOfBusinessChange === "user") {
      applyBusinessTheme(primaryColor);
    }
  }, [primaryColor, sourceOfBusinessChange]);

  useEffect(() => {
    if (isEmpty(notifications) && businessToken) {
      general.getNotification();
    }
  }, [businessToken]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setTopbarScrolled(currentScrollY > 8);

      if (currentScrollY > lastScrollY.current && currentScrollY > 80) {
        setTopbarHidden(true);
      } else {
        setTopbarHidden(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (userBusinesses?.length > 1)
      if (isEmpty(allBusinussArray)) {
        getBusinesses(businessToken);
      }
  }, [businessByToken]);

  const changeBusinessToken = (token, businessName) => {
    getcurrentBusinessBytoken(token, "user");
    reports.ClearReportAfterChange();
  };

  const clearCacheHander = async () => {
    setClearCacheLoading(true)
    try {
      const resp = await clearAllRedisDb();
      if (resp?.data?.success) message.success(resp?.data?.message ?? "کش ردیس با موفقیت پاک شد");
      setClearCacheLoading(false)
    } catch (error) {
      setClearCacheLoading(false)
      message.error(error)
    }
  }

  const onFullScreen = () => {
    var el = document.body;
    var requestMethod =
      el.requestFullScreen ||
      el.webkitRequestFullScreen ||
      el.mozRequestFullScreen ||
      el.msRequestFullScreen;

    if (requestMethod) {
      requestMethod.call(el);
    }
  };

  const handlePageTitle = (title) => {
    onPageTile(title);
  };

  const notifs = notifications?.length > 0
    ? notifications.slice(-3).map((notif, index) => ({
      key: index,
      label: (
        <div className="notif-item">
          <UserOutlined className="notif-icon" />
          <div>
            <div>{notif?.Description}</div>
            <div className="date-time">
              {strings.getFarsiNum(
                moment(notif?.NotifDate).format("jYYYY/jMM/jDD - HH:mm")
              )}
            </div>
          </div>
        </div>
      ),
    }))
    : [];

  const menu = [
    {
      key: 1,
      label: (
        <Link
          className=""
          to={`/${url}/profile`}
          onClick={() => handlePageTitle("پروفایل")}
        >
          <i className="mdi mdi-account"></i> پروفایل
        </Link>
      ),
    },
    {
      key: 2,
      label: (
        <Link
          className=""
          to={`/${url}/changePassword`}
          onClick={() => handlePageTitle("تغییر کلمه عبور")}
        >
          <i className="mdi mdi-onepassword"></i> تغییر کلمه عبور
        </Link>
      ),
    },
    {
      key: 3,
      label: (
        <div onClick={() => {
          logOut()
          RESET_APP()
        }}>
          <i
            className="mdi mdi-location-exit text-danger"
          >
            خروج
          </i>
        </div>
      )
    }
  ];

  return (
    <div id="layout-wrapper">
      <header
        id="page-topbar"
        className={`${topbarHidden ? "topbar-hidden" : ""} ${topbarScrolled ? "topbar-scrolled" : ""}`}
      >
        <div className="navbar-header">
          <div className="container-fluid">
            <div className="float-right d-flex align-items-baseline">

              {userInfo.Resources.includes('ClearCache') && userInfo.Resources.includes('CDN') &&
                <Tooltip
                  title="پاک کردن کش CDN (آروان)"
                  overlayStyle={{ top: 72 }}>

                  <div className="dropdown ml-1"
                    onClick={() => setCdnCacheModalOpen(true)}>
                    <button type="button" className="btn header-item noti-icon waves-effect" data-toggle="clearCDNCache">
                      <i className="mdi mdi-cloud-sync"></i>
                    </button>
                  </div>
                </Tooltip>}
              {userInfo && userInfo.Resources && userInfo.Resources.includes('ClearCache') && (
                <Tooltip title="پاک کردن کش Redis">
                  <span
                    style={{
                      display: 'inline-block',
                      cursor: clearCacheLoading ? 'not-allowed' : 'pointer',
                    }}
                  >
                    <button
                      disabled={clearCacheLoading}
                      onClick={clearCacheHander}
                      style={{
                        all: 'unset',
                        pointerEvents: clearCacheLoading ? 'none' : 'auto',
                        opacity: clearCacheLoading ? 0.5 : 1,
                      }}
                    >
                      <div
                        className="dropdown d-flex ml-1 h-auto"
                      >
                        <div
                          type="button"
                          className="btn header-item noti-icon waves-effect h-auto"
                          data-toggle="claerCache"
                        >
                          <i className="mdi mdi-cached"></i>
                        </div>
                      </div>
                    </button>
                  </span>
                </Tooltip>
              )}
              <div
                className="dropdown ml-1"
                onClick={toggleTheme}
              >
                <Tooltip
                  title={theme === "dark" ? "حالت روشن" : "حالت تاریک"}
                  overlayStyle={{ top: 72 }}>
                  <button
                    type="button"
                    className="btn header-item noti-icon waves-effect"
                    data-toggle="darkMode"
                  >
                    <span className={`theme-icon-toggle ${theme}`}>
                      <i className="mdi mdi-moon-waning-crescent theme-icon theme-icon-moon"></i>
                      <i className="mdi mdi-white-balance-sunny theme-icon theme-icon-sun"></i>
                    </span>
                  </button>
                </Tooltip>
              </div>
              <div
                className="dropdown d-none d-lg-inline-block ml-1"
                onClick={() => onFullScreen()}
              >
                <Tooltip
                  title="تمام صفحه"
                  overlayStyle={{ top: 72 }}>
                  <button
                    type="button"
                    className="btn header-item noti-icon waves-effect"
                    data-toggle="fullscreen"
                  >
                    <i className="mdi mdi-fullscreen"></i>
                  </button>
                </Tooltip>
              </div>
              <div className="dropdown d-none d-lg-inline-block btn">
                <Dropdown
                  overlayClassName="glass-dropdown "
                  menu={{
                    items: notifs,
                    onClick: () => navigate("/dashboard/notifications"),
                  }}
                >
                  <Badge
                    count={notifications && notifications.length}
                    overflowCount={99}
                    className="notif-icon"
                  >
                    <i
                      className="mdi mdi-bell-outline"
                      style={{ color: "#fff" }}
                    ></i>
                  </Badge>
                </Dropdown>
              </div>
              <div
                style={{
                  position: 'relative',
                  top: '12px'
                }}
                className={`dropdown d-inline-block ${isMobile || isTablet ? "pl-0" : ""}`} >
                <Dropdown
                  trigger={['click']}
                  placement="bottomRight"
                  getPopupContainer={(triggerNode) => triggerNode?.parentNode || document.body}
                  overlayClassName="glass-dropdown"
                  menu={{ items: menu }}>
                  <div className="ant-dropdown-link profileButton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">   <path d="M23.902 45c11.598 0 21-9.402 21-21s-9.402-21-21-21-21 9.402-21 21 9.402 21 21 21z" fill="#f6f6f6"></path>   <path fill="#e3e3e3" d="M24.335 25.162c-.14-.02-.32-.02-.48 0a6.54 6.54 0 0 1-6.32-6.54 6.55 6.55 0 0 1 6.56-6.56c3.62 0 6.56 2.94 6.56 6.56-.02 3.54-2.8 6.42-6.32 6.54zm13.242 13.197a19.868 19.868 0 0 1-13.48 5.24c-5.2 0-9.92-1.98-13.48-5.24.2-1.88 1.4-3.72 3.54-5.16 5.48-3.64 14.44-3.64 19.88 0 2.14 1.44 3.34 3.28 3.54 5.16z" class="fill-lighter-surface-color" stroke="#e3e3e3" stroke-width="2" stroke-linejoin="round"></path> </svg>
                    <span
                      className="d-none d-sm-inline-block ml-1"
                      style={{ paddingRight: "5px" }}
                    >
                      {userInfo && userInfo.DisplayName}
                    </span>
                    <i
                      className="mdi mdi-chevron-down d-none d-xl-inline-block"
                      style={{ paddingRight: "10px" }}
                    ></i>
                  </div>
                </Dropdown>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ width: "230px", marginTop: "20px" }}>
                {userBusinesses && userBusinesses.length > 0 && (
                  <div style={{ width: "90%", margin: "0 auto" }}>
                    <Select
                        showSearch
                        style={{ width: "100%" }}
                        placeholder="انتخاب کسب و کار"
                        optionFilterProp="children"
                        loading={businessLoading}
                        value={businessToken || userBusinesses[0].token}
                        getPopupContainer={(triggerNode) => triggerNode?.parentNode || document.body}
                        popupPlacement="bottomLeft"
                        onChange={(value) => {
                          const selectedBusiness = userBusinesses.find(b => b.Token === value);
                          changeBusinessToken(value, selectedBusiness?.Title);
                        }}
                        filterOption={(input, option) =>
                          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        options={userBusinesses.map(item => ({
                          value: item.Token,
                          label: item.Title
                        }))}
                      />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>


      <ClearCDNCacheModal
        open={cdnCacheModalOpen}
        setOpen={setCdnCacheModalOpen}
        onSubmit={clearCDNCaches}
      />
      {children}
    </div >
  );
};

export default Layout;
